import { toMoney } from '@mobi/utils/money'
import type { Campaign } from '../typings/types'
import dayjs from 'dayjs'

export const getTitleText = (campaign: Campaign): string => {
  switch (campaign.triggerType) {
    case 'AccountDepositTrigger':
      return 'Deposit Match Bonus'
    case 'AccountBetTrigger':
      return 'Bet Match Bonus'
    default:
      return 'Bonus Offer'
  }
}

export const getButtonText = (campaign: Campaign): string => {
  if (campaign.triggerType === 'AccountDepositTrigger') {
    if (campaign.isLive) {
      return 'Deposit Now'
    }
  }

  return 'Bet Now'
}

export const getTermsAndConditions = (campaign: Campaign): string => {
  const rewardExpiryDate = campaign.rewardExpiry
    ? dayjs(campaign.rewardExpiry).format('HH:mm, DD MMMM YYYY')
    : null
  const minimumBet = campaign.minimumAmount
    ? toMoney(campaign.minimumAmount, { decimalPlaces: 0 })
    : campaign.minimumAmount

  let minimumBetString = ''

  if (minimumBet && campaign.triggerType == 'AccountDepositTrigger') {
    minimumBetString = `Minimum deposit is ${minimumBet}. `
  } else {
    minimumBetString = `Minimum bet is ${minimumBet}. Not valid for multi bets, exotics or sports. `
  }

  if (campaign.isActivationPending) {
    return `Your bet has been successfully placed and is waiting to be resulted.`
  }

  if (campaign.isActivated && rewardExpiryDate) {
    return `Redeem offer by ${rewardExpiryDate}.`
  }

  return `${minimumBetString}`
}

export const getExpiryDate = (campaign: Campaign): string =>
  `Expires in ${dayjs(campaign.expiry).fromNow(true)}`

export const shouldDisplayCampaign = (campaign: Campaign): boolean => {
  return (
    campaign.isActivationPending ||
    (!campaign.isExpired && (campaign.isLive || campaign.isActivated))
  )
}

export const shouldDisplayAmounts = (campaign: Campaign): boolean => {
  return campaign.initialAmount > 0
}

export const getTotalAmount = (campaign: Campaign): string | null => {
  return campaign.initialAmount ? toMoney(campaign.initialAmount) : null
}

export const getRemainingAmount = (campaign: Campaign): string | null => {
  return campaign.remainingAmount ? toMoney(campaign.remainingAmount) : null
}

export const shouldShowButton = (campaign: Campaign): boolean => {
  return !campaign.isExpired && (campaign.isLive || campaign.isActivated)
}
